import { Table } from 'antd';
import type { TableColumnsType, TableProps, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';

export interface DTableProps<T> extends TableProps<T> {}
export interface DTableColumnsType<T> extends TableColumnsType<T> {}
export interface DTablePaginationConfig extends TablePaginationConfig {}
export interface DTableFilterValue extends FilterValue {}
export interface DTableSorterResult<T> extends SorterResult<T> {}

export const DarwinTable = <T,>({ ...props }: DTableProps<T>) => {
  return <Table {...props} />;
};
